import { useEffect } from "react"
import { useLocation } from "react-use"

export const ViewportMeta = () => {
  const location = useLocation()

  useEffect(() => {
    let metaTag: HTMLMetaElement | null = document.querySelector('meta[name="viewport"]')
    if (!metaTag) {
      metaTag = document.createElement("meta")
      metaTag.name = "viewport"
      document.head.appendChild(metaTag)
    }

    if (
      location.pathname?.includes("/auth/") ||
      location.pathname?.includes("/register-organization") ||
      location.pathname?.includes("/invitations")
    ) {
      metaTag.content = "width=device-width, initial-scale=1, maximum-scale=1"
    } else {
      metaTag.content = "width=1280"
    }
  }, [location.pathname])

  return null
}
